import useSWR from 'swr'
import { apiGet } from '@/lib/api'
import { useBusinessUnitStore } from '@/stores/businessUnitStore'
import { useEffect } from 'react'
import type { DashboardResponse } from '@/types'

const fetcher = (url: string) => apiGet<DashboardResponse>(url)

export function useDashboardData() {
  const selectedBuId = useBusinessUnitStore(s => s.selectedBuId)
  const setSelectedBuId = useBusinessUnitStore(s => s.setSelectedBuId)

  const url = selectedBuId ? `/api/dashboard/data?bu_id=${selectedBuId}` : '/api/dashboard/data'

  const { data, error, isLoading, mutate } = useSWR(['dashboard-data', selectedBuId], () => fetcher(url), {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    dedupingInterval: 60000,
  })

  // If selectedBuId is null and server picked a default, sync the store
  useEffect(() => {
    if (data?.current_bu_id && selectedBuId !== data.current_bu_id) {
      if (selectedBuId === null) setSelectedBuId(data.current_bu_id)
    }
  }, [data?.current_bu_id, selectedBuId, setSelectedBuId])

  return {
    dashboard: data ?? null,
    tasks: data?.data?.tasks ?? [],
    timesheets: data?.data?.timesheets ?? [],
    projects: data?.data?.projects ?? [],
    users: data?.data?.users ?? {},
    allEngineers: data?.data?.all_engineers ?? [],
    activeEngineers: data?.settings?.active_engineers ?? [],
    activeProjectIds: data?.settings?.active_project_ids ?? [],
    engineerRoles: data?.settings?.engineer_roles ?? {},
    odooUrl: data?.data?.odoo_web_url ?? '',
    currentUser: data?.user ?? null,
    businessUnits: data?.business_units ?? [],
    currentBuId: data?.current_bu_id ?? null,
    updatedAt: data?.updated_at ?? null,
    isLoading,
    error,
    mutate,
  }
}
